import ManagementRulesInput from './ManagementRulesInput'

export default ManagementRulesInput
